import { asyncRoutes, constantRoutes } from '@/router'

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  roles = roles.split(',')
  if (route.meta && route.meta.id) {
    return roles.indexOf('' + route.meta.id) != -1
  } else {
    return true
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  return res
}


const state = {
  routes: [], // 左侧菜单路由
  rights: [], // 权限列表
  loading: false,
  needcloud: '', // 是否自动接收报告
  needSign: '', // 是否需要上传签名
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.routes = routes
  },
  SET_RIGHTS: (state, rights) => {
    state.rights = rights
  },
  SET_LOADING: (state, loading) =>{
    state.loading = loading
  },
  SET_NEEDCLOUD: (state, needcloud) => {
    state.needcloud = needcloud
  },
  SET_NEEDSIGN: (state, needSign) => {
    state.needSign = needSign
  }
}

const actions = {
  
  generateRoutes({ commit }, roles) {
    return new Promise(resolve => {
      let accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    }).catch(err => {
      reject(err)
    })
  },
  setRights({ commit}, rights) {
    return new Promise(resolve => {
      commit('SET_RIGHTS', rights)
      resolve()
    }).catch(err => {
      reject(err)
    })
  },
  // 设置loading
  setLoading({ commit }, loading) {
    return new Promise(resolve => {
      commit('SET_LOADING', loading)
      resolve()
    }).catch(err => {
      reject(err)
    })
  },
  setNeedSign({commit},needSign) {
    return new Promise(resolve => {
      commit('SET_NEEDSIGN', needSign)
      resolve()
    }).catch(err => {
      reject(err)
    })
  },
  // 设置报告权限
  setReportPermission( {commit}, data) {
    return new Promise(resolve => {
    　const {  needcloud,show } = data
      commit('SET_NEEDCLOUD', needcloud)
      commit('SET_NEEDSIGN', show)
      resolve()
    }).catch(err => {
      reject(err)
    })
  },
  //　清除权限
  clearPermisson( {commit}) {
      return new Promise(resolve =>{
          commit('SET_NEEDCLOUD', '')
          resolve()
      }).catch(err => {
        reject(err)
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
